<template>
  <div class="infinite-scroll" v-if="hasMoreData">
    <spinner />
  </div>
</template>

<script>
import Spinner from './Spinner';

export default {
  components: {
    Spinner,
  },

  props: {
    loading: Boolean,
    hasMoreData: Boolean,
    scrollParentId: String,
    endThresholdOffset: {
      type: Number,
      default: 100,
    },
  },

  data() {
    return {
      scrollParent: window,
    };
  },

  mounted() {
    if (this.scrollParentId) {
      this.scrollParent = document.getElementById(this.scrollParentId);
    }

    this.scrollParent.addEventListener('scroll', this.checkScroll);
  },

  destroyed() {
    this.scrollParent.removeEventListener('scroll', this.checkScroll);
  },

  methods: {
    checkScroll() {
      if (this.loading || !this.hasMoreData) return;

      const scrollContainer = this.scrollParentId
        ? this.scrollParent
        : document.documentElement || document.body;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

      if (scrollTop + clientHeight > scrollHeight - this.endThresholdOffset) {
        this.$emit('load');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.infinite-scroll {
  padding: $gp;
  position: relative;
  margin-top: $gp;
}
</style>
